import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  WAREHOUSE_AREAS_INDEX_REQUESTED,
  WAREHOUSE_AREAS_INDEX_SUCCESS,
  WAREHOUSE_AREAS_INDEX_FAILURE,
  WAREHOUSE_AREAS_BREAKDOWN_REQUESTED,
  WAREHOUSE_AREAS_BREAKDOWN_SUCCESS,
  WAREHOUSE_AREAS_BREAKDOWN_FAILURE,
  WAREHOUSE_AREAS_FORGET_REQUESTED,
  WAREHOUSE_AREAS_FORGET_SUCCESS,
  WAREHOUSE_AREAS_FORGET_FAILURE,
  WAREHOUSE_LABEL_PRINT_REQUESTED,
  WAREHOUSE_LABEL_PRINT_SUCCESS,
  WAREHOUSE_LABEL_PRINT_FAILURE,
} from '../types';

export const warehouseAreasIndex = (signedPayload, filters = {}) => {
  return (dispatch) => {
    dispatch({ type: WAREHOUSE_AREAS_INDEX_REQUESTED });

    let endPoint = Config.baseUrl + Config.warehouseAreas;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    let params = {};
    if (filters.search) {
      params.search = filters.search;
    }
    if (filters.depth) {
      params.depth = filters.depth;
    }

    return Axios.get(endPoint, { headers: headers, params: params })
      .then((response) => {
        dispatch({ type: WAREHOUSE_AREAS_INDEX_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: WAREHOUSE_AREAS_INDEX_FAILURE, error: error });
      });
  }
}

export const warehouseAreasBreakdown = (signedPayload) => {
  return (dispatch) => {
    dispatch({ type: WAREHOUSE_AREAS_BREAKDOWN_REQUESTED });

    let endPoint = Config.baseUrl + Config.warehouseAreasBreakdown;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, {}, { headers: headers })
      .then((response) => {
        dispatch({ type: WAREHOUSE_AREAS_BREAKDOWN_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: WAREHOUSE_AREAS_BREAKDOWN_FAILURE, error: error });
      });
  }
}

export const warehouseAreasForget = (signedPayload) => {
  return (dispatch) => {
    dispatch({ type: WAREHOUSE_AREAS_FORGET_REQUESTED });

    let endPoint = Config.baseUrl + Config.warehouseAreas;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch({ type: WAREHOUSE_AREAS_FORGET_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: WAREHOUSE_AREAS_FORGET_FAILURE, error: error });
      });
  }
}

export const warehouseLabelPrint = (signedPayload, options) => {
  return (dispatch) => {
    dispatch({ type: WAREHOUSE_LABEL_PRINT_REQUESTED });

    let endPoint = Config.baseUrl + Config.warehouseLabelsPrint;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, options, { headers: headers })
      .then((response) => {
        dispatch({ type: WAREHOUSE_LABEL_PRINT_SUCCESS, payload: response.data.downloadUrl });
      })
      .catch((error) => {
        dispatch({ type: WAREHOUSE_LABEL_PRINT_FAILURE, error: error });
      });
  }
}
